import { getContext } from 'svelte';
const getCardContext = () => {
    const card = getContext('card');
    if (!card) {
        throw new Error('Card must be called inside a card context');
    }
    return card;
};
export { getCardContext };
